<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.58)"
  template="<img src='./spinner_load.svg' alt='' />"
  [fullScreen]="true"
>
  <div class="main-view__loading-status" role="status" aria-live="polite" aria-atomic="true">
    {{ _loading.message() }}
  </div>
</ngx-spinner>
<router-outlet />
